<template>
	<card class="is-card-table has-pagination has-table-borderless has-bottom-left-hidden" title="店舗一覧" icon="format-list-bulleted">
		<b-button slot="button" type="is-success" @click="onNewButtonClick">新規作成</b-button>
		<shop-table-toolbar slot="toolbar" :customers="customers" @search-button-click="onSearchButtonClick"/>
		<shop-table :data="data" :totalNum="totalNum" :isLoading="isLoading" :checkable="false"/>
	</card>
</template>

<script>
import Card from "@/components/Card";
import ShopTable from "@/components/ShopTable";
import ShopTableToolbar from "@/components/ShopTableToolbar";
import qs from 'qs';

export default {
	name: 'shop',
	components: {
		Card,
		ShopTable,
		ShopTableToolbar,
	},
	data() {
		return {
			data: [],
			isLoading: false,
			totalNum: 0,
			customers: [],
		}
	},
	mounted() {
		this.init();
		this.$store.commit('basic', {
			key: 'titleBarTitleStack',
			value: ['店舗管理']
		});
	},
	methods: {
		onNewButtonClick: function() {
			this.$router.push({ name: 'shop-new' });
		},
		onSearchButtonClick: function(isHiddenContain, customerId) {
			this.getData(isHiddenContain, customerId);
		},
		init: function() {
			this.getData();
		},
		getData: async function(isHiddenContain = 0, customerId = '') {
			this.isLoading = true;
			let data = {
				"is_hidden_contain": isHiddenContain,
				"customer_id": customerId,
			};
			this.$utils.log(data);

			let ep = 'shops?' + qs.stringify(data);
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				if (!res.data.list) {
					this.data = [];
				} else {
					this.data = res.data.list;
				}
				this.totalNum = this.data.length;
				this.customers = res.data.customers;
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
	},
}
</script>

<style scoped>
</style>
